import {Alert} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {removeAlert} from 'shared/actions';
import {AlertModel} from 'shared/models/AlertModel';

interface SnackbarItemProps {
  notif: AlertModel;
}
const SnackbarItem: React.FC<SnackbarItemProps> = (props) => {
  const {notif} = props;
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false); // pour l'entrée
  const [leaving, setLeaving] = useState(false); // pour la sortie

  // déclenche l'animation d'entrée au montage
  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
  }, []);

  // auto-fermeture
  useEffect(() => {
    const timer = setTimeout(() => close(), 4000);
    return () => clearTimeout(timer);
  }, []);

  function close() {
    setLeaving(true);
    if (!notif.unClearOnClose) {
      setTimeout(() => dispatch(removeAlert(notif.id)), 300); // attend la fin de l'anim sortie
    }
  }

  return (
    <Alert
      onClose={close}
      severity={notif.type}
      //variant='filled'
      sx={{
        width: 320,
        boxShadow: 3,
        transition: 'transform 300ms ease, opacity 300ms ease',
        transform: visible && !leaving ? 'translateX(0)' : 'translateX(calc(100% + 24px))',
        opacity: visible && !leaving ? 1 : 0,
      }}>
      {notif.message}
    </Alert>
  );
};

export default SnackbarItem;
